export const supplierPlanMixin = {
    methods: {
        formatPriceWithSpaces: function (price) {
            if (typeof price === 'string') {
                return price;
            }

            const formatedPrice = price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

            return formatedPrice;
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/supplierPlan.js